import styled from "@emotion/styled";
import ProCard from "@ant-design/pro-card";
import { Table } from "antd";
import th from "../../../../../images/th1.png";
import tr from "../../../../../images/tr.png";
import { QueryFilter } from "@ant-design/pro-form";
import { useState, useEffect, useCallback } from "react";
import { menuMap } from "./config";
import { debug } from "console";
const Layout = styled.div`
  .flex {
    display: flex;
  }
  .ac {
    align-items: center;
  }
  .column {
    flex-direction: column;
  }
  .box-item {
    background-color: rgba(1, 104, 126, 0.9);
    border: 2px solid #00c9d0;
    box-shadow: 0 0 12px #00383f;
    border-radius: 8px;
    padding: 20px 25px;
    width: 1545px;
    margin-top: 15px;
  }

  .all {
    padding: 25px 25px;
    text-align: center;
  }

  .title {
    font-size: 50px;
    font-family: Source Han Sans CN;
    font-weight: 800;
    color: #feffff;
    span {
      color: #00eafe;
    }
  }
  .table-box {
    .table-title {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #d6fdff;
      margin-bottom: 21px;
    }
  }

  .ant-table {
    background-color: transparent;
    thead {
      background-image: url(${th});
    }
    th {
      background-color: transparent !important;
      color: #fff !important;
      font-size: 14px !important;
      border: none !important;
      height: 40px !important;
      padding: 0 !important;
      &::before {
        display: none !important;
      }
    }
    td {
      color: #1cfbff !important;
      border: none !important;
      background-color: transparent !important;
    }
    tr:hover {
      td {
        background-color: transparent !important;
        border: none !important;
      }
    }
    tbody tr {
      background-image: url(${tr});
      border: none !important;
      &:nth-child(odd) {
        // background-image: url();
      }
    }
  }
`;
export const CommonStaticTable: React.FC<{
  columns: any[];
  dataSource: any[];
}> = ({ columns, dataSource }) => {
  return (
    <Layout>
      <Table
        columns={columns}
        rowKey={(record: any) => record.id}
        dataSource={dataSource || []}
        locale={{
          emptyText: "暂无数据",
        }}
      />
    </Layout>
  );
};
export const CommonTablePage: React.FC<{
  type: string;
  param?: any;
}> = ({ type, param }) => {
  const [setting, setSetting] = useState({ ...menuMap[type] });
  const [loading, setLoading] = useState(false);
  const [tableParams, setTableParams] = useState<any>({
    pagination: {
      current: 1,
      pageSize: setting?.table.pageSize || 10,
    },
    filters: {},
  });
  const [typeList, setTypeList] = useState([]);

  const getList = async () => {
    try {
      setLoading(true);
      const tempSetting = menuMap[type];
      const extralParam = tempSetting.listExtraParam
        ? tempSetting.listExtraParam()
        : {};

      const res: any = await tempSetting.table.list({
        pagesize: tableParams.pagination.pageSize,
        page: tableParams.pagination.current,
        ...tableParams.filters,
        ...extralParam,
        ...(param || {}),
      });
      setTypeList(res.data || []);
      setLoading(false);
      setTableParams({
        ...tableParams,
        pagination: {
          ...tableParams.pagination,
          total: res.total,
        },
      });
    } catch (e) {}
  };
  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });
  };
  useEffect(() => {
    if (type) {
      setSetting({
        ...menuMap[type],
      });
    }
  }, [type]);
  useEffect(() => {
    getList();
  }, [JSON.stringify(tableParams), type, JSON.stringify(param || {})]);
  return (
    <Layout>
      {setting.filter && (
        <ProCard>
          <QueryFilter
            resetText=""
            searchText="搜索"
            defaultColsNumber={24}
            onFinish={async (values: object) => {
              if (setting.filter.beforeFilter) {
                values = setting.filter.beforeFilter(values);
              }
              setTableParams({
                ...tableParams,
                filters: { ...values },
              });
            }}
          >
            {setting.filter.child()}
          </QueryFilter>
        </ProCard>
      )}
      <Table
        columns={setting.table.columns({
          ...param,
          tableParams,
        })}
        rowKey={(record: any) => record.id}
        dataSource={typeList || []}
        pagination={tableParams.pagination}
        loading={loading}
        onChange={handleTableChange}
        locale={{
          emptyText: "暂无数据",
        }}
      />
    </Layout>
  );
};
